import { Spinner } from "react-bootstrap"
import LocalizedStrings from 'react-localization';

import { ClientLanguage, getClientLanguageAsString } from "../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        messageApplicationUploaded:"Bewerbung wird hochgeladen...",
    },
    en: 
    {
        messageApplicationUploaded:"Application is being uploaded....",
    }
});

interface PendingViewProps{
    message: string
    clientLanguage?: ClientLanguage
}

export const PendingView = (props: PendingViewProps) => {

    setLanguage();

    function setLanguage(): void {
        switch(props.clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }

    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "30px" }}>
            <Spinner animation="border" role="status" style={{ padding: "20px", margin: "30px"}}>
                <span className="visually-hidden">{locStrings.messageApplicationUploaded}</span>
            </Spinner>
            <div>{props.message}</div>
        </div>

    )
}